import $ from 'jquery';
import analytics from '../utils/analytics';

class Common {
  constructor() {}

  init() {
    this.setupAnalytics();
  }

  setupAnalytics() {
    $('.ga-img-click').on('click', (e) => {
      const target = $(e.currentTarget);
      let data = {
        title: target.data('img-title'),
      };
      analytics.gtmClickEvent('imageClick', data);
    });

    $('.ga-video-click').on('click', (e) => {
      const target = $(e.currentTarget);
      let data = {
        title: target.data('video-title'),
      };
      analytics.gtmClickEvent('videoClick', data);
    });

    $('.accordion-button').on('click', (e) => {
      const target = $(e.currentTarget);
      let data = {
        title: target.text().trim(),
      };
      analytics.gtmClickEvent('accordionClick', data);
    });

    $('.ga-cs-click').on('click', (e) => {
      const target = $(e.currentTarget).find('h3');
      let data = {
        title: target.text().trim(),
      };
      analytics.gtmClickEvent('caseStudyClick', data);
    });

    $('.ga-cs-link-click a').on('click', (e) => {
      const parent = $(e.target).closest('.ga-cs-link-click');
      const target = $(parent).find('h3');
      let data = {
        title: target.text().trim(),
      };
      analytics.gtmClickEvent('caseStudyClick', data);
    });

    window.analyticsSetup = true;
  }
}

export default Common;
